import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/svg/icons/microphone.svg")